export default __webpack_public_path__ + "static/media/Ordenamiento_Territorial.9357ffff.jpg";